// extracted by mini-css-extract-plugin
export default {"placeholder":"MarketingPrototype_placeholder__vgYaF"};